<template>
    <div class="cookies-consent" v-if="show">
        <template v-if="!rejectStep">
            <div class="cookies-consent__image">
                <img class="cookies-consent__image"
                     v-bind:src="staticPathRoot + '/images/cookie-01.png'"
                     alt=""
                />
            </div>
            <div class="cookies-consent__text">
                Пользуясь сайтом, вы соглашаетесь <a v-bind:href="urls.policy" target="_blank">со сбором данных cookies</a>, необходимых для его работоспособности.
            </div>
            <div class="cookies-consent__button">
                <ui-button
                    v-on:click="submit"
                    is-uppercase
                >
                    Хорошо
                </ui-button>
            </div>
            <div class="cookies-consent__button-reject"
                 v-on:click="rejectStep = true"
            >
                Отказаться
            </div>
        </template>
        <template v-else>
            <div class="cookies-consent__image">
                <img class="cookies-consent__image"
                     v-bind:src="staticPathRoot + '/images/cookie-02.png'"
                     alt=""
                />
            </div>
            <div class="cookies-consent__text">
                ヽ(⚬_⚬)ノ Без использования <a v-bind:href="urls.policy" target="_blank">cookies</a>, сайт не сможет работать, но вы всегда можете посетить наши офлайн-магазины.
            </div>
            <div class="cookies-consent__button">
                <ui-button
                    v-on:click="submit"
                    is-uppercase
                >
                    Остаться на сайте с cookies
                </ui-button>
            </div>
        </template>
    </div>
</template>

<script>
import config from '~/config';

export default {
    name: 'cookies-consent',
    inject: [ 'staticPathRoot' ],
    props: {

    },
    data: () => ({
        show: false,
        rejectStep: false,
        urls: {
            policy: config.urls.policy,
        },
    }),
    methods: {
        submit() {
            const key = config.localStorage.prefix + config.localStorage.affixes.cookie.consent;
            const timeKey = config.localStorage.prefix + config.localStorage.affixes.cookie.timestamp;
            window.localStorage.setItem(key, 1);
            window.localStorage.setItem(timeKey, Date.now());
            this.show = false;
        },
    },
    mounted() {
        const key = config.localStorage.prefix + config.localStorage.affixes.cookie.consent;
        const consent = window.localStorage.getItem(key);
        this.show = consent === null;
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.cookies-consent {
    .mixin-modal();

    position: fixed;
    left: 20px;
    bottom: 20px;
    z-index: 100;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    max-width: 340px;
    min-height: 323px;
    padding: 0 20px 20px 20px;

    box-shadow: 0 0 60px 0 @color-accent-cold;

    &__image {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px 0;
        img {
            width: 140px;
            height: 140px;
        }
    }
    &__text {
        padding-bottom: 12px;
    }
    &__button {
        flex-shrink: 0;
        height: 48px;
        &-reject {
            .mixin-link-decoration();

            margin-top: 14px;
            text-align: center;
            cursor: pointer;
        }
    }
    @media @media-md-down {
        max-width: 340px;
        min-height: 323px;
        padding: 0 20px 20px 20px ;
    }
    @media @media-sm-down {
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>
